var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedemptionsImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 250.772,
    height: 196.219,
    viewBox: "0 0 250.772 196.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    transform: "translate(0.004 -0.003)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 43.743,
    cy: 8.287,
    rx: 43.743,
    ry: 8.287,
    transform: "translate(44.22 175.848)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M240.927,82.7c-16.077-.556-31.388-5.748-46.009-11.426S165.815,59.31,150.124,56.3c-10.093-1.935-21.636-2.211-29.766,3.194-7.827,5.216-10.356,14.2-11.715,22.535-1.023,6.275-1.625,12.88,1.177,18.754,1.947,4.079,5.4,7.507,7.79,11.414,8.314,13.593,2.437,30.355-6.57,43.627-4.223,6.225-9.129,12.172-12.39,18.792s-4.769,14.231-1.915,21c2.827,6.707,9.566,11.734,16.866,15.274,14.827,7.191,32.292,9.248,49.335,10.415,37.715,2.578,75.628,1.463,113.442.343,13.995-.412,28.049-.832,41.816-3,7.646-1.2,15.538-3.11,21.089-7.715,7.045-5.845,8.791-15.741,4.069-23.069-7.919-12.3-29.808-15.349-35.35-28.541-3.045-7.263.082-15.351,4.511-22.085,9.5-14.45,25.419-27.125,26.256-43.639.576-11.342-7.077-22.7-18.911-28.069-12.4-5.626-29.6-4.918-38.751,4.394C271.681,79.51,255.123,83.2,240.927,82.7Z",
    transform: "translate(-95.23 -55.03)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M395.655,217.126,388.047,212h0l3.838-5.713-20.1-1.6-7.221,5.584-9.039-5.067-7.539.907-.089-1.987a56.086,56.086,0,0,0-.624-6.185c.032-.621.055-1.334.052-2.109,0-3.266-.442-7.6-2.385-10.483l.447-4.019-3.627-4.285a27.418,27.418,0,0,1,1.987-3.343c.124-.179.248-.353.383-.522a9.019,9.019,0,0,0,8.421-8.942,5.722,5.722,0,0,0-.025-.653,2.362,2.362,0,0,0-.027-.263c.46.248.924.5,1.389.745.087.124.186.248.3.395h0l.022.027.139.171.045.052c.05.06.1.117.154.176l.035.04c.132.147.271.3.42.442a.447.447,0,0,1,.05.047l.186.174.052.047c.159.142.328.278.5.407l.055.04.214.147.07.045c.082.05.166.1.248.149l.03.017c.1.052.2.1.3.149l.05.02.248.1.077.027c.087.03.171.057.261.082l.055.015c.109.027.219.05.33.067h.012a2.7,2.7,0,0,0,.318.032h.072a2.728,2.728,0,0,0,.286,0h.062a2.94,2.94,0,0,0,.355-.042,3.92,3.92,0,0,0,1.565-.561,1.365,1.365,0,0,0,.318-.3,1.171,1.171,0,0,0-.05-1.364h0c-.194-.462-1.451-.787-1.451-.787s-3.974-1.659-3.974-2.981-.994-8.177-11.25-9.745c0,0-6.672-.375-8.548,3.2l-.04.417c-.551.345-1.009,1.038-1.552,1.242a2.535,2.535,0,0,0-.673.248v-.047h0a.641.641,0,0,0-.152.2,1.988,1.988,0,0,0-.206.745,2.806,2.806,0,0,1-.325.9,2.006,2.006,0,0,1-.149.229h0l-.042.067a1.813,1.813,0,0,0,.845-.137,4.206,4.206,0,0,1-.248.994.825.825,0,0,0,.765-.457v-.02l.032-.045a2.1,2.1,0,0,0,.154-.36l-.027.03c.05-.161.094-.325.149-.484a.76.76,0,0,1,.122-.248.6.6,0,0,1,.514-.171l-.1,2.154h.045a2.937,2.937,0,0,1-.219.452c-.353.571-.994.961-1.23,1.587a2.336,2.336,0,0,0-.114.939c0,.186.022.375.037.561v-.015a2.1,2.1,0,0,1-.224,1.369c-.184.273-.479.479-.581.79a.769.769,0,0,0-.037.268,3.014,3.014,0,0,0,.169.8.035.035,0,0,0,0-.015,1.213,1.213,0,0,1,.042.586c-.112.5-.715.912-.686,1.386a.534.534,0,0,0,.027.184,1.006,1.006,0,0,0,.561.5,2.186,2.186,0,0,0,1.262.278,1.659,1.659,0,0,0,.472-.161c-.174.4-.353.795-.534,1.17-.027.06-.057.119-.087.179,0,0-1.535-1.026-2.407,1.066a4.641,4.641,0,0,0-.539,1.4,3.333,3.333,0,0,1-.184.576,3.709,3.709,0,0,1-1.659,1.49c-1.779.815-8.962,9.775-9.089,12.095a13.535,13.535,0,0,1-.457,2.678,15.935,15.935,0,0,0-.427,6.332,12.116,12.116,0,0,0,.44,2.02,45.25,45.25,0,0,1,1.272,6.642l.825,7.507a21.362,21.362,0,0,0,.134,3.1c-.842.961-4.223,4.968-2.931,6.059.994.859,2.732.718,3.709.542a31.562,31.562,0,0,0-2.288,8c-.248,3.594.425,8.356,1.49,10.184s4.618,6.518,4.618,6.518-.166,6.434,1.1,8.771,1.781,7.186,1.781,7.186,1.185,4.094.591,5.6,1.1,2.757-.678,3.758-4.054,23.563-4.054,23.563-.917,14.787,0,15.54a.93.93,0,0,0,.156.092v4.968s-.636,1.043,1.95,1.254c1.771.142,6.791.462,9.77.648l2.308.144s5.465,1.088,7.879,0,6.694-1.063,6.059-3.937a8.172,8.172,0,0,0-.338-1.15c-.7-1.784-1.883-1.987-4.066-2.484-.127-.027-.248-.052-.36-.072-2.3-.4-3.055.671-4.345-.723-1.12-1.2-4.687-2.554-5.9-2.981.03-.089.067-.176.1-.268a1.819,1.819,0,0,1-.922-.45l3.291.209,1.96.122s4.645.927,6.707,0,5.688-.9,5.147-3.344a7.01,7.01,0,0,0-.286-.979c-.594-1.515-1.6-1.682-3.458-2.1-.107-.022-.206-.045-.306-.062-1.955-.34-2.6.569-3.691-.614-.939-1.008-3.9-2.139-4.968-2.524,0-.551-.745-1.336-1.215-2.124-.551-.919.467-4.136.467-4.136l.581-13.347a2.578,2.578,0,0,1,.7-.2s2.628-2.509,2.034-5.182a17.17,17.17,0,0,1-.189-2.442,12.545,12.545,0,0,0,2.392-2.718c.551-1.19,0-6.955,0-6.955V237.691l4.4.445,3.989.41,1.215.124,3.989.4,9.168.927,8.262-1.565,3.574-.676,7.35-1.391V218.383Zm-60.513-59.594-.512-.055C334.8,157.485,334.978,157.517,335.142,157.532Z",
    transform: "translate(-262.734 -127.267)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M500.266,436.55c-2.484,3.555-11.414,1.672-11.414,1.672l-6.92-6.476-.931-.877,1.562-3.319s.5.137,1.349.38C488.385,429.229,502.362,433.561,500.266,436.55Z",
    transform: "translate(-385.177 -335.013)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M483.906,427.93a14.571,14.571,0,0,1-1.975,3.815l-.931-.877,1.562-3.319S483.064,427.687,483.906,427.93Z",
    transform: "translate(-385.177 -335.013)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M378.762,278.1s-6.379,2.829-6.066,9.777a114.546,114.546,0,0,0,1.461,13.354s-1.3,10.455,4.126,13.15,10.455,4.911,10.455,4.911,8.5.914,9.551,1.292,4.354-5.4,3.746-6.294-8.406-2.785-9.4-4.285a8.3,8.3,0,0,0-3.291-2.427s-2.372-1.436-2.534-2.732a5.9,5.9,0,0,1,.624-2.832c.159-.569.561-6.061.561-6.061S390.673,276.408,378.762,278.1Z",
    transform: "translate(-303.768 -222.611)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M390.009,370.39s-8.751,1.466-7.9,4.528A18.553,18.553,0,0,1,390.009,370.39Z",
    transform: "translate(-310.805 -292.052)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M402.291,375.38s-4.812,3.927-3.87,4.128S402.291,375.38,402.291,375.38Z",
    transform: "translate(-323.019 -295.802)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M421.4,380.89s-1.289,2.641-.5,2.462S421.4,380.89,421.4,380.89Z",
    transform: "translate(-339.813 -299.943)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M403.79,316.651l-.532-.152a1.519,1.519,0,0,0,.07-1.086c-.609-.9-8.4-2.782-9.392-4.285a8.251,8.251,0,0,0-3.291-2.427s-2.372-1.436-2.534-2.732a5.9,5.9,0,0,1,.623-2.832c.159-.569.561-6.063.561-6.063s2.67-19.547-9.241-17.85c0,0-6.379,2.832-6.068,9.78a114.236,114.236,0,0,0,1.463,13.354s-1.3,10.455,4.126,13.15,10.455,4.911,10.455,4.911,8.493.912,9.551,1.292c.4.144,1.123-.6,1.831-1.62l.4.375,6.92,6.473s8.93,1.885,11.414-1.669C422.249,322.28,408.274,317.947,403.79,316.651Z",
    transform: "translate(-304.738 -223.453)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M377.845,169.117a2.112,2.112,0,0,0-.688.266c-.248.206-.248.559-.31.867a2.852,2.852,0,0,1-.5,1.187,1.786,1.786,0,0,0,.827-.137,4.258,4.258,0,0,1-.248.994.8.8,0,0,0,.745-.455,4.786,4.786,0,0,0,.311-.872.718.718,0,0,1,.119-.248c.229-.271.653-.149,1.006-.114a1.652,1.652,0,0,0,1.51-.725c.375-.569.4-2.024-.5-2.178C379.189,167.547,378.608,168.834,377.845,169.117Z",
    transform: "translate(-306.522 -139.702)",
    fill: "#965d7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(69.865 29.617)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M378.313,174.62c.022-.122.037-.248.065-.37h0a1.457,1.457,0,0,0-.311.867,2.73,2.73,0,0,1-.147.524A2.846,2.846,0,0,0,378.313,174.62Z",
    transform: "translate(-377.567 -174.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M377.325,180.994a4.13,4.13,0,0,0,.248-.994,1.778,1.778,0,0,1-.787.137,2.876,2.876,0,0,1-.286.5,1.769,1.769,0,0,0,.825-.134,4.131,4.131,0,0,1-.248.994.807.807,0,0,0,.745-.455,1.852,1.852,0,0,0,.149-.355.745.745,0,0,1-.646.311Z",
    transform: "translate(-376.5 -178.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M385.007,175.359c-.353-.035-.78-.156-1.009.114a.768.768,0,0,0-.119.248c-.022.065-.042.132-.06.2.236-.186.618-.087.939-.055a1.659,1.659,0,0,0,1.51-.725,1.376,1.376,0,0,0,.166-.39A1.654,1.654,0,0,1,385.007,175.359Z",
    transform: "translate(-382.002 -174.626)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M313.354,201l3.788,4.556-.494,4.6-4.578-7.166Z",
    transform: "translate(-234.554 -151.069)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M317.14,205.556l-.465,4.325-.03.273-4.131-6.468-.445-.7.129-.2L313.352,201l.256.308Z",
    transform: "translate(-234.554 -151.069)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M388.151,210.944a7.6,7.6,0,0,0-3.572,3.162,26.991,26.991,0,0,0-1.928,3.314c-.35.7-.658,1.374-.914,1.96l-.179.417c-.432,1.021-.673,1.7-.673,1.7s-9.812-7.378-8.259-7.874c.522-.166,1.207-1.284,1.885-2.693l.084-.179c.43-.9.852-1.913,1.227-2.862.768-1.95,1.336-3.644,1.336-3.644S392.063,209.827,388.151,210.944Z",
    transform: "translate(-303.598 -167.181)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M459.26,202.58s2.265,4.1,5.308,3.54,1.791-2.2,1.791-2.2Z",
    transform: "translate(-368.838 -165.926)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M386.378,744.463c-2.007.917-6.545,0-6.545,0l-1.913-.119c-2.484-.159-6.642-.427-8.113-.546-2.146-.176-1.62-1.056-1.62-1.056v-5.313L378.6,734.79s4.116,1.408,5.244,2.638c1.071,1.172,1.7.271,3.607.609.094.017.194.037.3.062,1.813.415,2.8.579,3.378,2.082a6.989,6.989,0,0,1,.281.969C391.944,743.568,388.382,743.551,386.378,744.463Z",
    transform: "translate(-300.345 -565.934)",
    fill: "#a36468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M391.127,750a7.788,7.788,0,0,1-1.172.6c-1.366.623-2.665,1.384-4.046,1.972a9.465,9.465,0,0,1-4.364.9,6.509,6.509,0,0,0-2.33-.025,5.384,5.384,0,0,0-1.294.718c-2.484-.159-6.642-.427-8.113-.546-2.146-.176-1.62-1.056-1.62-1.056v-.621c.077,0,.164-.022.263-.03a4.691,4.691,0,0,1,1.515.226c1.078.293,2.151.581,3.229.869a2.551,2.551,0,0,1,1.242-1.585,3.959,3.959,0,0,1,2-.46c1.672.022,3.254.815,4.923.894a2.713,2.713,0,0,0,1.364-.229c.229-.114.43-.281.653-.407a4.768,4.768,0,0,1,1.125-.38,24.774,24.774,0,0,0,3.217-1.038c.3-.117.646-.328.606-.646-.052-.422-.715-.472-.889-.859a.5.5,0,0,1,.02-.44c.094.017.194.037.3.062C389.562,748.337,390.546,748.5,391.127,750Z",
    transform: "translate(-300.345 -575.758)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M368.1,786.084c-2.36,1.078-7.7,0-7.7,0l-2.248-.132c-2.911-.186-7.815-.5-9.546-.643-2.526-.209-1.905-1.242-1.905-1.242V777.8l12.254-3.105s4.844,1.657,6.17,3.105c1.259,1.379,1.987.318,4.245.715.112.02.229.045.35.072,2.134.5,3.291.683,3.974,2.452a7.973,7.973,0,0,1,.33,1.14C374.636,785.031,370.455,785.009,368.1,786.084Z",
    transform: "translate(-284.184 -595.93)",
    fill: "#a36468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M373.685,792.641a9.246,9.246,0,0,1-1.379.708c-1.607.733-3.137,1.627-4.762,2.32a11.162,11.162,0,0,1-5.137,1.056,7.494,7.494,0,0,0-2.732-.03,6.332,6.332,0,0,0-1.528.854c-2.911-.186-7.815-.5-9.546-.643-2.526-.209-1.905-1.242-1.905-1.242v-.73a3.1,3.1,0,0,1,.31-.035,5.45,5.45,0,0,1,1.784.266l3.8,1.023a3.006,3.006,0,0,1,1.473-1.865,4.635,4.635,0,0,1,2.357-.542c1.967.027,3.828.959,5.793,1.053a3.208,3.208,0,0,0,1.6-.266c.271-.137.5-.333.77-.479a5.406,5.406,0,0,1,1.324-.447,29.74,29.74,0,0,0,3.766-1.222c.35-.139.76-.388.713-.76-.062-.5-.842-.556-1.048-1.013a.6.6,0,0,1,.025-.517c.112.02.229.045.35.072C371.844,790.679,373,790.873,373.685,792.641Z",
    transform: "translate(-284.184 -607.528)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M386.92,647.54l-.663,15.607s-.994,3.187-.455,4.1,1.448,1.821,1.118,2.36-4.3,6.367-5.589,4.131-2.551-11.923-2.551-11.923l1.185-11.965Z",
    transform: "translate(-308.349 -500.357)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M411.856,491l1.843,2.464V514.9s.539,5.713,0,6.893-3.271,3.54-3.271,3.54l-2.3-11.8.5-12.482Z",
    transform: "translate(-330.408 -382.702)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M386.92,647.54l-.663,15.607s-.994,3.187-.455,4.1,1.448,1.821,1.118,2.36-4.3,6.367-5.589,4.131-2.551-11.923-2.551-11.923l1.185-11.965Z",
    transform: "translate(-308.349 -500.357)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M411.856,491l1.843,2.464V514.9s.539,5.713,0,6.893-3.271,3.54-3.271,3.54l-2.3-11.8.5-12.482Z",
    transform: "translate(-330.408 -382.702)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M352.722,436.162v11.593l-2.069,9.024s-.663,21.777-.084,24.425-1.987,5.134-1.987,5.134-1.49.166-1.49,1.324-2.484,4.471-2.484,4.471l.082,6.458s1.078,12.09-.579,14.407.579,2.65.579,2.65c-2.069,6.789-12.005,5.216-12.9,4.471s0-15.4,0-15.4,2.221-22.356,3.96-23.35.084-2.236.663-3.726-.579-5.547-.579-5.547-.5-4.8-1.739-7.122-1.078-8.694-1.078-8.694-3.478-4.638-4.511-6.458-1.7-6.54-1.451-10.1a31.74,31.74,0,0,1,2.236-7.929c.385-.966.663-1.592.663-1.592l.236.062,13.568,3.552Z",
    transform: "translate(-269.431 -337.005)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M398.321,210.892a7.6,7.6,0,0,0-3.572,3.162h-.278a8.873,8.873,0,0,1-7.7-4.454,8.738,8.738,0,0,1-.78-1.776c.768-1.95,1.336-3.644,1.336-3.644S402.233,209.774,398.321,210.892Z",
    transform: "translate(-313.768 -167.128)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M402.14,179.31a8.88,8.88,0,1,1-16.613-4.352,8.676,8.676,0,0,1,.939-1.356,8.987,8.987,0,0,1,2.042-1.793,8.88,8.88,0,0,1,13.62,6.851C402.133,178.878,402.14,179.094,402.14,179.31Z",
    transform: "translate(-312.558 -141.757)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M385.719,245.677l-.03.273-4.131-6.458c-.432,1.021-.673,1.7-.673,1.7s-9.812-7.387-8.259-7.884c.522-.166,1.207-1.284,1.885-2.693l.084-.179c.72,2.146,4.906,6.436,6.647,8.155.2.2.368.363.5.482l.266.248.139.139C382.778,240.118,385.451,243,385.719,245.677Z",
    transform: "translate(-303.598 -186.865)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M349.744,267.373l-.452,14.549-.079,2.591s-5.356-.5-10.353-1.043a67.417,67.417,0,0,1-8.4-1.192,15.813,15.813,0,0,0-3.6-.792c-.974-.132-1.739-.2-1.739-.2s-.286.084-.725.164c-.959.174-2.643.315-3.624-.537-1.254-1.09,2.042-5.052,2.864-6l.181-.206-.31-2.869-.807-7.44a45.39,45.39,0,0,0-1.242-6.583,12.14,12.14,0,0,1-.43-2,16.017,16.017,0,0,1,.417-6.275,13.683,13.683,0,0,0,.447-2.655c.124-2.3,7.142-11.178,8.88-11.985a3.686,3.686,0,0,0,1.779-1.774,3.387,3.387,0,0,0,.271-.773c.745-3.229,2.631-1.947,2.631-1.947.455,2.526,7.492,9.213,7.492,9.213l.139.139c.7.715,3.808,4.074,3.587,6.94a8.413,8.413,0,0,0,.469,3.14,53.1,53.1,0,0,1,2.447,13.91Z",
    transform: "translate(-264.536 -186.647)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M388.26,310.45s-1.739,4.223-3.043,4.906S388.881,316.8,388.26,310.45Z",
    transform: "translate(-313.022 -247.001)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M391.354,342.2s-3.974.5-3.974,1.242S391.354,342.2,391.354,342.2Z",
    transform: "translate(-314.813 -270.864)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M397.184,361.7s-5.775,12.3-7.39,12.668S397.184,361.7,397.184,361.7Z",
    transform: "translate(-316.481 -285.52)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M378.542,241.7l-4.777,2.077L368,235.07a3.387,3.387,0,0,0,.271-.773c.745-3.229,2.631-1.947,2.631-1.947.455,2.526,7.492,9.213,7.492,9.213Z",
    transform: "translate(-300.247 -188.113)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M379.542,239.7l-4.777,2.077L369,233.07a3.39,3.39,0,0,0,.271-.773c.745-3.229,2.631-1.947,2.631-1.947.455,2.526,7.492,9.213,7.492,9.213Z",
    transform: "translate(-300.998 -186.609)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M357.022,330.873s-5.356-.5-10.353-1.043l8.967,2.347v2.732c-.392.355-.733.539-.954.445-1.033-.435-9.467-1.8-9.467-1.8s-4.9-2.484-10.184-5.465a4.087,4.087,0,0,1-.373-.234,5.871,5.871,0,0,1-1.565-1.567,11.124,11.124,0,0,1-1.659-5.01,21.666,21.666,0,0,1-.129-3.075,25.217,25.217,0,0,1,.318-3.475,114.277,114.277,0,0,1-.745-13.414c.062-6.955,6.583-9.439,6.583-9.439,11.985-1.056,8.269,18.32,8.269,18.32s-.693,5.465-.882,6.024a5.9,5.9,0,0,0-.775,2.794c.092,1.3,2.382,2.864,2.382,2.864a8.364,8.364,0,0,1,3.157,2.6c.671,1.145,5.028,2.7,7.489,3.806Z",
    transform: "translate(-272.345 -233.008)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M401.2,170.3a2.812,2.812,0,0,1-.248,1.187,7.338,7.338,0,0,1-.442.884,4.074,4.074,0,0,1-1.088,1.351,5.565,5.565,0,0,1-1.987.691,2.876,2.876,0,0,0-1.8,1.018,3.562,3.562,0,0,0-.42,1.217,2.618,2.618,0,0,1-.5,1.177.976.976,0,0,1-1.163.278,1.175,1.175,0,0,1-.45-.579,8.3,8.3,0,0,1-.469-2.034,4.329,4.329,0,0,0-.7-1.95,1.746,1.746,0,0,0-1.833-.7,1.766,1.766,0,0,0-.994.964,5.524,5.524,0,0,0-.375,1.371q-.462,2.529-1.09,5.028a.462.462,0,0,1-.082.189.358.358,0,0,1-.248.1c-.556.075-1.09-.315-1.652-.273a.949.949,0,0,0-.171.027,8.875,8.875,0,0,1,.9-10.135l.045-.012a2.678,2.678,0,0,0,.994-.626,10.49,10.49,0,0,0,.994-1.15l.2-.248a11.329,11.329,0,0,1,1.938-1.841,1.987,1.987,0,0,1,.661-.358,1.957,1.957,0,0,1,.626-.02,15.79,15.79,0,0,0,2.586.1,16.592,16.592,0,0,1,1.816-.184,5.59,5.59,0,0,1,3.907,2.372A3.674,3.674,0,0,1,401.2,170.3Z",
    transform: "translate(-312.504 -138.259)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M376.575,170.968c-.345.566-.969.951-1.2,1.572-.343.9.236,2.024-.3,2.829-.176.271-.467.472-.566.782-.169.524.293,1.083.174,1.622s-.83.994-.641,1.52a.994.994,0,0,0,.547.5,2.136,2.136,0,0,0,1.242.276c.678-.112,1.182-.777,1.87-.827.559-.04,1.093.348,1.649.276a.373.373,0,0,0,.248-.107.43.43,0,0,0,.082-.189q.626-2.5,1.093-5.028a5.415,5.415,0,0,1,.373-1.371,1.781,1.781,0,0,1,.994-.964,1.752,1.752,0,0,1,1.833.7,4.3,4.3,0,0,1,.7,1.95,8.412,8.412,0,0,0,.467,2.034,1.187,1.187,0,0,0,.452.581.973.973,0,0,0,1.16-.278,2.591,2.591,0,0,0,.5-1.18,3.548,3.548,0,0,1,.42-1.215,2.882,2.882,0,0,1,1.8-1.018,5.62,5.62,0,0,0,1.987-.693,4.088,4.088,0,0,0,1.088-1.349,3.971,3.971,0,0,0,.681-2.074,3.808,3.808,0,0,0-1.018-2.149,5.583,5.583,0,0,0-3.91-2.37,15.45,15.45,0,0,0-1.816.184,15.545,15.545,0,0,1-2.586-.1,2.032,2.032,0,0,0-.626.022,1.873,1.873,0,0,0-.658.358,11.336,11.336,0,0,0-1.94,1.838,14.235,14.235,0,0,1-1.2,1.391,2.7,2.7,0,0,1-.994.628c-.248.07-.5.02-.733.1C377.012,169.45,376.916,170.406,376.575,170.968Z",
    transform: "translate(-304.765 -137.53)",
    fill: "#965d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M464.568,206.117c-1.987.365-3.634-1.242-4.546-2.414a9.743,9.743,0,0,1-.763-1.123l6.821,1.287.276.052S467.611,205.561,464.568,206.117Z",
    transform: "translate(-368.838 -165.926)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(69.235 31.542)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M376.08,211.284a2.069,2.069,0,0,0-.144-.954c0,.025-.022.05-.03.075a1.849,1.849,0,0,0,.129,1.023A.746.746,0,0,0,376.08,211.284Z",
    transform: "translate(-375.395 -203.293)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M379.054,197.8a5.519,5.519,0,0,0,.02,1.031,5.535,5.535,0,0,0-.02-1.031Z",
    transform: "translate(-377.778 -193.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M392.491,183.6a4.074,4.074,0,0,1-1.088,1.351,5.549,5.549,0,0,1-1.987.691,2.869,2.869,0,0,0-1.8,1.018,3.579,3.579,0,0,0-.42,1.217,2.6,2.6,0,0,1-.5,1.18.969.969,0,0,1-1.16.278,1.187,1.187,0,0,1-.452-.581,8.27,8.27,0,0,1-.467-2.034,4.292,4.292,0,0,0-.7-1.95,1.746,1.746,0,0,0-1.833-.7,1.774,1.774,0,0,0-.994.964,5.414,5.414,0,0,0-.373,1.371q-.464,2.531-1.093,5.028a.429.429,0,0,1-.082.189.373.373,0,0,1-.248.107c-.556.072-1.09-.315-1.649-.276-.688.05-1.192.715-1.87.825a2.1,2.1,0,0,1-1.242-.276,1.329,1.329,0,0,1-.455-.323.671.671,0,0,0-.092.579.969.969,0,0,0,.546.5,2.1,2.1,0,0,0,1.242.276c.678-.109,1.182-.775,1.87-.825.559-.04,1.093.348,1.649.276a.373.373,0,0,0,.248-.107.43.43,0,0,0,.082-.189q.626-2.484,1.093-5.028a5.417,5.417,0,0,1,.373-1.371,1.773,1.773,0,0,1,.994-.964,1.748,1.748,0,0,1,1.833.7,4.3,4.3,0,0,1,.7,1.95,8.412,8.412,0,0,0,.467,2.034,1.187,1.187,0,0,0,.452.581.973.973,0,0,0,1.16-.278,2.6,2.6,0,0,0,.5-1.18,3.58,3.58,0,0,1,.42-1.217,2.894,2.894,0,0,1,1.8-1.018,5.666,5.666,0,0,0,1.987-.691,4.074,4.074,0,0,0,1.088-1.351,3.956,3.956,0,0,0,.681-2.072,2.663,2.663,0,0,0-.03-.283A4.881,4.881,0,0,1,392.491,183.6Z",
    transform: "translate(-373.964 -182)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M404.46,174.982a8.776,8.776,0,0,1,1.105,3.689c-2.213-1.242-4.295-2.606-5.346-3.08-1.831-.827-8.677-.7-11.25-.626a8.677,8.677,0,0,1,.939-1.356,8.988,8.988,0,0,1,2.049-1.793,8.885,8.885,0,0,1,12.514,3.162Z",
    transform: "translate(-316.008 -141.763)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M465.189,205.064c-1.195.368-3.145-.343-5.167-1.361a9.743,9.743,0,0,1-.763-1.123l6.821,1.287C466.533,204.175,466.647,204.614,465.189,205.064Z",
    transform: "translate(-368.838 -165.926)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M394.286,154.046s-6.521-.373-8.354,3.167l-.3,3.137-.5-.055-.1,2.134s9.966-.435,12.234.589,9.315,6.18,12.139,5.311-.248-1.677-.248-1.677-3.887-1.647-3.887-2.939S404.313,155.6,394.286,154.046Z",
    transform: "translate(-313.054 -129.439)",
    fill: "#444053"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M371.63,622.28s4.161,4.036,5.962,3.726C377.592,626.006,372.5,625.571,371.63,622.28Z",
    transform: "translate(-302.975 -481.372)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M368.13,629.81s.373,2.077,1.366,1.873S368.13,629.81,368.13,629.81Z",
    transform: "translate(-300.344 -487.031)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M379.178,769.53s-5.907,4.6-4.911,4.72S379.178,769.53,379.178,769.53Z",
    transform: "translate(-304.872 -592.045)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M330.96,337.912l19.127-3.112v18.108l-18.173-.951Z",
    transform: "translate(-248.752 -251.633)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M330.96,337.912l19.127-3.112v18.108l-18.173-.951Z",
    transform: "translate(-248.752 -251.633)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M407.96,334.8l22.937,1.716-1.269,15.759-21.668.633Z",
    transform: "translate(-306.625 -251.633)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M407.96,334.8l22.937,1.716-1.269,15.759-21.668.633Z",
    transform: "translate(-306.625 -251.633)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M415.012,312.55l-7.052,5.527,22.937,1.716,3.748-5.656Z",
    transform: "translate(-306.625 -234.91)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M303.08,316.686l17.219-2.1,8.833,5.02-19.127,3.112Z",
    transform: "translate(-227.798 -236.443)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M354.28,348.92v24.758l-8.96-.919-3.9-.4-1.187-.124-3.895-.4-5.38-.551V347.33l19.124,1.3Z",
    transform: "translate(-248.752 -261.05)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M443.584,341.71v24.145l-7.181,1.379-3.493.671-8.071,1.55V344.7Z",
    transform: "translate(-319.312 -256.826)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M443.584,341.71v24.145l-7.181,1.379-3.493.671-8.071,1.55V344.7Z",
    transform: "translate(-319.312 -256.826)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M303.08,352.541l6.925-5.211,23.32,1.59-3.433,5.783Z",
    transform: "translate(-227.798 -261.05)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M303.08,352.541l6.925-5.211,23.32,1.59-3.433,5.783Z",
    transform: "translate(-227.798 -261.05)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M443.584,341.71,424.84,344.7l6.1,5.465,20.078-3.368Z",
    transform: "translate(-319.312 -256.826)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M443.584,341.71,424.84,344.7l6.1,5.465,20.078-3.368Z",
    transform: "translate(-319.312 -256.826)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M460.823,428.383l-3.493.671v-5.159l3.271-.825Z",
    transform: "translate(-343.732 -317.976)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M376.977,435.96v3.413l-3.9-.4V435.96Z",
    transform: "translate(-280.409 -327.664)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M356.515,440.29v1.816l-3.895-.4V440.29Z",
    transform: "translate(-265.032 -330.919)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M453.351,453.636c-2.67,3.416-11.489,1.056-11.489,1.056l-6.553-6.836-.889-.927,1.739-3.229s.5.164,1.326.452C441.877,445.687,455.6,450.762,453.351,453.636Z",
    transform: "translate(-350.168 -347.151)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M452.351,451.636c-2.67,3.415-11.489,1.056-11.489,1.056l-6.553-6.836-.889-.927,1.739-3.229s.5.164,1.326.452C440.877,443.687,454.6,448.762,452.351,451.636Z",
    transform: "translate(-349.416 -345.648)",
    fill: "#efb7b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M436.445,442.152a14.686,14.686,0,0,1-2.176,3.7l-.889-.927,1.739-3.229S435.618,441.864,436.445,442.152Z",
    transform: "translate(-349.386 -345.648)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M338.461,287.871s-6.521,2.484-6.583,9.439a114.29,114.29,0,0,0,.745,13.414s-1.863,10.371,3.416,13.352,10.184,5.465,10.184,5.465,8.433,1.366,9.469,1.8,4.635-5.154,4.076-6.086-8.237-3.229-9.149-4.782a8.272,8.272,0,0,0-3.157-2.6s-2.29-1.562-2.382-2.867a5.868,5.868,0,0,1,.775-2.794c.191-.559.884-6.024.884-6.024S350.446,286.8,338.461,287.871Z",
    transform: "translate(-273.097 -229.999)",
    fill: "#dce6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M345.651,380.7s-8.818.994-8.135,4.1A18.552,18.552,0,0,1,345.651,380.7Z",
    transform: "translate(-277.306 -299.801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M357.675,385.7s-5.005,3.664-4.086,3.912S357.675,385.7,357.675,385.7Z",
    transform: "translate(-289.331 -303.559)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M376.753,391.7s-1.428,2.568-.621,2.434S376.753,391.7,376.753,391.7Z",
    transform: "translate(-306.173 -308.068)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M723.505,167.383s-9.439-.569-8.336,6.054a1.615,1.615,0,0,0,.84,1.7s.017-.5.969-.325a4.349,4.349,0,0,0,1.026.05,2.129,2.129,0,0,0,1.257-.519h0s2.655-1.1,3.689-5.437c0,0,.765-.949.745-1.192l-1.595.683a2.858,2.858,0,0,1,.114,2.106s-.05-2.064-.358-2.017c-.062,0-.827.4-.827.4s.937,2,.229,3.46c0,0,.268-2.469-.522-3.316l-1.123.656a4.956,4.956,0,0,1,.353,3.758s.191-2.591-.589-3.6l-1.018.792s1.031,2.042.4,3.443c0,0-.082-3.016-.623-3.244a6.145,6.145,0,0,0-1.023,1.108s.7,1.49.266,2.263c0,0-.268-2.01-.5-2.02a6.687,6.687,0,0,0-.979,2.236,4.834,4.834,0,0,1,.763-2.37,2.66,2.66,0,0,0-1.356.7s.137-.941,1.575-1.023a6.8,6.8,0,0,1,.929-1.073,5.824,5.824,0,0,0-2.3.266,2.6,2.6,0,0,1,2.561-.5l.994-.82a8.571,8.571,0,0,0-2.683.027s.919-.785,2.954-.214l1.093-.653a9.814,9.814,0,0,0-2.561-.221,3.929,3.929,0,0,1,2.881.045l.782-.35s-1.177-.231-1.52-.268-.363-.132-.363-.132a4.064,4.064,0,0,1,2.208.248A9.745,9.745,0,0,0,723.505,167.383Z",
    transform: "translate(-561.111 -139.463)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M838.965,300.723s-9.439-.569-8.336,6.054a1.615,1.615,0,0,0,.84,1.7s.017-.5.971-.325a4.35,4.35,0,0,0,1.026.05,2.126,2.126,0,0,0,1.242-.517h0s2.658-1.1,3.691-5.44c0,0,.763-.946.733-1.19l-1.595.681a2.866,2.866,0,0,1,.117,2.106s-.052-2.064-.358-2.017c-.062,0-.83.4-.83.4s.939,2,.231,3.46c0,0,.268-2.469-.524-3.316l-1.11.648a4.956,4.956,0,0,1,.353,3.758s.191-2.591-.589-3.6l-1.016.795s1.028,2.039.4,3.44c0,0-.082-3.016-.623-3.244a6.232,6.232,0,0,0-1.026,1.108s.706,1.49.268,2.263c0,0-.268-2.01-.5-2.02a6.687,6.687,0,0,0-.979,2.236,4.849,4.849,0,0,1,.765-2.37,2.673,2.673,0,0,0-1.359.7s.139-.941,1.577-1.023a6.2,6.2,0,0,1,.929-1.073,5.825,5.825,0,0,0-2.3.266,2.58,2.58,0,0,1,2.559-.484l.994-.82a8.574,8.574,0,0,0-2.683.027s.919-.785,2.953-.214l1.093-.653a9.954,9.954,0,0,0-2.564-.221,3.937,3.937,0,0,1,2.884.045l.782-.35s-1.177-.231-1.523-.268-.363-.132-.363-.132a4.072,4.072,0,0,1,2.211.248A10.025,10.025,0,0,0,838.965,300.723Z",
    transform: "translate(-647.89 -239.681)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M614.116,248.841s2.174-9.213-4.543-9.245a1.614,1.614,0,0,0-1.818.537s.479.1.154,1.011a4.422,4.422,0,0,0-.224.994,2.134,2.134,0,0,0,.3,1.324h0s.628,2.807,4.72,4.566c0,0,.8.914,1.048.924l-.4-1.687a2.854,2.854,0,0,1-2.1-.248s2.044.3,2.047,0c0-.062-.248-.884-.248-.884s-2.134.581-3.45-.365c0,0,2.387.686,3.358.052l-.447-1.222a4.957,4.957,0,0,1-3.766-.293s2.521.631,3.649.035l-.609-1.138s-2.186.666-3.46-.191c0,0,2.981.432,3.3-.06a6.17,6.17,0,0,0-.917-1.2s-1.58.442-2.275-.122c0,0,2.024.077,2.072-.137a6.7,6.7,0,0,0-2.044-1.349,4.869,4.869,0,0,1,2.208,1.158,2.681,2.681,0,0,0-.462-1.458s.9.3.745,1.739a6.186,6.186,0,0,1,.9,1.1,5.842,5.842,0,0,0,.129-2.31,2.582,2.582,0,0,1,.042,2.606l.636,1.13a8.244,8.244,0,0,0,.43-2.648s.619,1.038-.293,2.946l.46,1.19a9.947,9.947,0,0,0,.653-2.484,3.927,3.927,0,0,1-.537,2.834l.214.83s.427-1.12.522-1.453.191-.335.191-.335a4.069,4.069,0,0,1-.619,2.136A9.868,9.868,0,0,0,614.116,248.841Z",
    transform: "translate(-480.385 -193.678)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M517.9,282.51s-7.581-5.671-10.291.472a1.617,1.617,0,0,0-.233,1.883s.283-.4.994.263a4.349,4.349,0,0,0,.83.606,2.131,2.131,0,0,0,1.334.248h0s2.822.544,6.071-2.514c0,0,1.16-.373,1.269-.591l-1.711-.3A2.87,2.87,0,0,1,515.1,284.4s1.091-1.754.807-1.88c-.057-.027-.912-.124-.912-.124s-.318,2.191-1.709,3.018c0,0,1.582-1.915,1.386-3.058l-1.3-.07a4.955,4.955,0,0,1-1.771,3.336s1.582-2.059,1.49-3.331l-1.287.1s-.261,2.268-1.555,3.093c0,0,1.587-2.564,1.262-3.05a6.244,6.244,0,0,0-1.466.36s-.226,1.625-1.021,2.037c0,0,.882-1.826.7-1.952a6.678,6.678,0,0,0-2.052,1.334,4.851,4.851,0,0,1,1.943-1.56,2.675,2.675,0,0,0-1.52-.159s.631-.71,1.878.012a6.271,6.271,0,0,1,1.366-.385,5.812,5.812,0,0,0-2.067-1.041,2.586,2.586,0,0,1,2.407.994l1.289-.132a8.507,8.507,0,0,0-2.255-1.451s1.2-.152,2.583,1.443l1.272.057a9.916,9.916,0,0,0-2.017-1.595,3.928,3.928,0,0,1,2.382,1.622l.847.137s-.857-.84-1.125-1.058-.231-.311-.231-.311a4.081,4.081,0,0,1,1.711,1.421A10.041,10.041,0,0,0,517.9,282.51Z",
    transform: "translate(-404.837 -224.208)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M619.506,70.4s-7.581-5.673-10.291.472a1.617,1.617,0,0,0-.234,1.883s.283-.4.994.263a4.42,4.42,0,0,0,.832.6,2.129,2.129,0,0,0,1.334.248h0s2.822.544,6.071-2.516c0,0,1.16-.37,1.267-.591l-1.711-.3a2.857,2.857,0,0,1-1.061,1.823s1.093-1.754.81-1.88c-.057-.027-.912-.124-.912-.124s-.328,2.2-1.719,3.018c0,0,1.58-1.915,1.386-3.058l-1.3-.07a4.959,4.959,0,0,1-1.771,3.334s1.582-2.059,1.49-3.331l-1.284.1s-.263,2.27-1.557,3.1c0,0,1.59-2.564,1.264-3.05a6.245,6.245,0,0,0-1.466.36s-.226,1.625-1.021,2.037c0,0,.882-1.826.7-1.955a6.7,6.7,0,0,0-2.052,1.336,4.829,4.829,0,0,1,1.943-1.56,2.658,2.658,0,0,0-1.523-.159s.633-.71,1.88.012a6.135,6.135,0,0,1,1.366-.385,5.845,5.845,0,0,0-2.067-1.043,2.59,2.59,0,0,1,2.4.994l1.289-.132a8.518,8.518,0,0,0-2.255-1.453s1.2-.149,2.586,1.446l1.272.055a9.815,9.815,0,0,0-2.02-1.592,3.929,3.929,0,0,1,2.385,1.622l.845.137s-.859-.83-1.128-1.043-.231-.308-.231-.308a4.074,4.074,0,0,1,1.711,1.421A10.725,10.725,0,0,0,619.506,70.4Z",
    transform: "translate(-481.206 -64.783)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M738.346,87.592s-3.031-8.97-8.746-5.445a1.633,1.633,0,0,0-1.259,1.418s.46-.169.663.775a4.471,4.471,0,0,0,.34.971,2.151,2.151,0,0,0,.954.966h0s2.017,2.049,6.429,1.371c0,0,1.165.353,1.379.231l-1.242-1.22a2.857,2.857,0,0,1-1.908.9s1.9-.825,1.739-1.09c-.032-.052-.681-.616-.681-.616s-1.505,1.622-3.12,1.515c0,0,2.387-.681,2.874-1.739l-1.028-.792a4.95,4.95,0,0,1-3.351,1.739s2.484-.8,3.112-1.9l-1.118-.643s-1.49,1.721-3.036,1.667c0,0,2.762-1.21,2.77-1.8a6.21,6.21,0,0,0-1.411-.534s-1.108,1.21-1.987,1.1c0,0,1.759-1.006,1.684-1.212a6.665,6.665,0,0,0-2.447-.062,4.841,4.841,0,0,1,2.484-.186,2.68,2.68,0,0,0-1.165-.994s.924-.226,1.543,1.076a6.255,6.255,0,0,1,1.341.457,5.838,5.838,0,0,0-1.11-2.029,2.587,2.587,0,0,1,1.413,2.191l1.138.621a8.384,8.384,0,0,0-1.036-2.484s1.076.556,1.309,2.655l1.018.768a9.874,9.874,0,0,0-.76-2.459,3.933,3.933,0,0,1,1.043,2.69l.619.591s-.229-1.177-.323-1.51-.017-.355-.017-.355a4.1,4.1,0,0,1,.6,2.141A9.9,9.9,0,0,0,738.346,87.592Z",
    transform: "translate(-571.078 -74.791)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M662.729,108.149s-9.414-1.048-8.637,5.631a1.612,1.612,0,0,0,.745,1.739s.042-.5.994-.273a4.571,4.571,0,0,0,1.023.1,2.136,2.136,0,0,0,1.279-.455h0s2.71-.961,3.974-5.246c0,0,.81-.907.792-1.153l-1.627.6a2.77,2.77,0,0,1,0,2.109s.052-2.064-.248-2.032c-.062,0-.847.358-.847.358s.835,2.049.055,3.478c0,0,.392-2.454-.355-3.339l-1.155.6a4.937,4.937,0,0,1,.161,3.773s.323-2.578-.4-3.624l-1.056.745s.924,2.089.226,3.458c0,0,.072-3.016-.457-3.271a6.463,6.463,0,0,0-1.081,1.053s.628,1.515.154,2.273c0,0-.166-2.02-.385-2.039a6.68,6.68,0,0,0-1.093,2.191,4.836,4.836,0,0,1,.884-2.33,2.673,2.673,0,0,0-1.391.633s.184-.932,1.625-.941c0,0,.782-.971.994-1.023a5.84,5.84,0,0,0-2.31.149,2.577,2.577,0,0,1,2.581-.355l1.046-.768a8.056,8.056,0,0,0-2.69-.134s.959-.745,2.961-.062l1.125-.6a9.891,9.891,0,0,0-2.549-.35,3.9,3.9,0,0,1,2.876.191l.8-.311s-1.165-.291-1.508-.345-.355-.149-.355-.149a4.086,4.086,0,0,1,2.2.358A10.162,10.162,0,0,0,662.729,108.149Z",
    transform: "translate(-515.239 -94.907)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M994.344,402.319s-9.409-1.048-8.632,5.624a1.612,1.612,0,0,0,.745,1.739s.042-.5.994-.276a4.3,4.3,0,0,0,1.023.1,2.119,2.119,0,0,0,1.279-.455h0s2.71-.961,3.962-5.244c0,0,.81-.909.792-1.153l-1.627.6a2.777,2.777,0,0,1,0,2.111s.052-2.067-.248-2.032c-.062,0-.847.355-.847.355s.835,2.049.055,3.478c0,0,.392-2.452-.355-3.339l-1.155.6a4.945,4.945,0,0,1,.164,3.773s.32-2.578-.407-3.627l-1.056.745s.924,2.089.226,3.455c0,0,.072-3.016-.457-3.269a6.561,6.561,0,0,0-1.081,1.053s.631,1.515.154,2.273c0,0-.166-2.02-.385-2.039a6.68,6.68,0,0,0-1.093,2.191,4.836,4.836,0,0,1,.884-2.33,2.651,2.651,0,0,0-1.391.633s.184-.934,1.625-.944c0,0,.785-.971.994-1.021a5.82,5.82,0,0,0-2.31.147,2.584,2.584,0,0,1,2.583-.353l1.043-.768a8.3,8.3,0,0,0-2.68-.109s.959-.745,2.961-.065l1.125-.6a9.891,9.891,0,0,0-2.549-.35,3.9,3.9,0,0,1,2.876.191l.8-.313s-1.165-.291-1.508-.343-.355-.149-.355-.149a4.071,4.071,0,0,1,2.2.355A9.73,9.73,0,0,0,994.344,402.319Z",
    transform: "translate(-764.484 -316.004)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M1052.254,437.7s-9.409-1.046-8.632,5.624a1.617,1.617,0,0,0,.745,1.739s.042-.5.994-.273a4.385,4.385,0,0,0,1.021.1,2.146,2.146,0,0,0,1.274-.452h0s2.708-.961,3.959-5.246c0,0,.812-.907.792-1.153l-1.627.6a2.777,2.777,0,0,1,0,2.111s.052-2.064-.248-2.032c-.062,0-.847.355-.847.355s.835,2.049.055,3.478c0,0,.392-2.452-.355-3.336l-1.155.6a4.945,4.945,0,0,1,.164,3.773s.32-2.578-.407-3.624l-1.056.745s.924,2.089.229,3.458c0,0,.07-3.018-.459-3.271a6.561,6.561,0,0,0-1.081,1.053s.631,1.515.154,2.273c0,0-.167-2.02-.385-2.039a6.643,6.643,0,0,0-1.091,2.191,4.85,4.85,0,0,1,.882-2.33,2.673,2.673,0,0,0-1.391.633s.186-.934,1.627-.941c0,0,.782-.971.994-1.023a5.84,5.84,0,0,0-2.31.149,2.581,2.581,0,0,1,2.583-.355l1.043-.768a8.3,8.3,0,0,0-2.68-.109s.959-.745,2.961-.062l1.125-.6a9.891,9.891,0,0,0-2.549-.35,3.9,3.9,0,0,1,2.876.191l.8-.31s-1.165-.291-1.505-.345-.358-.149-.358-.149a4.086,4.086,0,0,1,2.2.358A9.83,9.83,0,0,0,1052.254,437.7Z",
    transform: "translate(-808.009 -342.597)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M917.446,132.65s-7.581-5.671-10.291.472a1.617,1.617,0,0,0-.233,1.883s.283-.4.994.263a4.349,4.349,0,0,0,.83.606,2.134,2.134,0,0,0,1.334.248h0s2.822.544,6.073-2.514c0,0,1.158-.373,1.267-.591l-1.706-.308a2.87,2.87,0,0,1-1.061,1.823s1.09-1.754.807-1.88c-.057-.027-.909-.124-.909-.124s-.32,2.191-1.711,3.018c0,0,1.582-1.915,1.386-3.058l-1.3-.07a4.955,4.955,0,0,1-1.771,3.336s1.585-2.059,1.49-3.331l-1.287.1s-.248,2.268-1.555,3.093c0,0,1.59-2.564,1.262-3.05a6.244,6.244,0,0,0-1.466.36s-.224,1.625-1.018,2.037c0,0,.879-1.826.7-1.952a6.677,6.677,0,0,0-2.052,1.334,4.851,4.851,0,0,1,1.943-1.56,2.675,2.675,0,0,0-1.52-.159s.633-.71,1.88.012a6.245,6.245,0,0,1,1.364-.385,5.813,5.813,0,0,0-2.067-1.041,2.586,2.586,0,0,1,2.407.994l1.289-.132a8.464,8.464,0,0,0-2.255-1.451s1.2-.152,2.583,1.443l1.274.057a9.959,9.959,0,0,0-2.019-1.595,3.921,3.921,0,0,1,2.382,1.622l.847.137s-.857-.84-1.125-1.058-.229-.291-.229-.291a4.084,4.084,0,0,1,1.709,1.421A9.975,9.975,0,0,0,917.446,132.65Z",
    transform: "translate(-705.138 -111.573)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M943.824,284.9s-2.613-9.1-8.49-5.832a1.614,1.614,0,0,0-1.324,1.359s.467-.147.628.8a4.4,4.4,0,0,0,.3.994,2.134,2.134,0,0,0,.909,1.013h0s1.923,2.136,6.359,1.659c0,0,1.148.4,1.366.293l-1.175-1.277a2.856,2.856,0,0,1-1.945.815s1.928-.745,1.779-1.011c-.03-.055-.651-.648-.651-.648s-1.575,1.555-3.185,1.374c0,0,2.417-.571,2.948-1.6l-.994-.84a4.963,4.963,0,0,1-3.425,1.59s2.5-.688,3.194-1.759l-1.088-.693s-1.577,1.652-3.107,1.528c0,0,2.814-1.086,2.849-1.669a6.2,6.2,0,0,0-1.389-.6s-1.16,1.158-2.042,1.009c0,0,1.8-.927,1.739-1.135a6.708,6.708,0,0,0-2.442-.174,4.846,4.846,0,0,1,2.484-.072A2.665,2.665,0,0,0,936,278.989s.934-.186,1.49,1.143a6.2,6.2,0,0,1,1.319.517,5.809,5.809,0,0,0-1.018-2.077,2.58,2.58,0,0,1,1.314,2.251l1.108.673a8.26,8.26,0,0,0-.924-2.519s1.048.6,1.19,2.71l.994.812a9.852,9.852,0,0,0-.648-2.484,3.925,3.925,0,0,1,.922,2.732l.591.621s-.174-1.187-.248-1.525,0-.385,0-.385a4.071,4.071,0,0,1,.509,2.166A9.855,9.855,0,0,0,943.824,284.9Z",
    transform: "translate(-725.659 -222.882)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M706.729,372.9s-5.075-7.994-9.787-3.209a1.607,1.607,0,0,0-.889,1.677s.41-.273.832.6a4.253,4.253,0,0,0,.561.859,2.122,2.122,0,0,0,1.155.715h0s2.447,1.51,6.57-.2c0,0,1.215.065,1.394-.1l-1.49-.894a2.855,2.855,0,0,1-1.639,1.329s1.644-1.242,1.423-1.471c-.042-.045-.807-.437-.807-.437s-1.076,1.933-2.67,2.213c0,0,2.159-1.23,2.382-2.367l-1.19-.524a4.948,4.948,0,0,1-2.839,2.484s2.211-1.364,2.571-2.586l-1.242-.358s-1.048,2.029-2.551,2.34c0,0,2.395-1.833,2.263-2.4a6.169,6.169,0,0,0-1.49-.181s-.787,1.438-1.677,1.543c0,0,1.471-1.4,1.349-1.58a6.693,6.693,0,0,0-2.392.522,4.834,4.834,0,0,1,2.37-.77,2.666,2.666,0,0,0-1.364-.688s.842-.44,1.739.678a6.136,6.136,0,0,1,1.413.124,5.718,5.718,0,0,0-1.562-1.707s1.167.1,1.893,1.791l1.254.333a8.3,8.3,0,0,0-1.595-2.156s1.175.283,1.9,2.268l1.172.5a9.9,9.9,0,0,0-1.324-2.206,3.914,3.914,0,0,1,1.652,2.362l.745.43s-.5-1.09-.673-1.391-.107-.37-.107-.37a4.074,4.074,0,0,1,1.1,1.935A10.1,10.1,0,0,0,706.729,372.9Z",
    transform: "translate(-546.794 -290.381)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M841.172,207.874s-4.826-8.145-9.688-3.51a1.615,1.615,0,0,0-.939,1.649s.415-.263.812.619a4.293,4.293,0,0,0,.534.879,2.109,2.109,0,0,0,1.133.745h0s2.4,1.585,6.573,0c0,0,1.212.1,1.4-.06l-1.458-.939a2.856,2.856,0,0,1-1.679,1.277s1.682-1.2,1.471-1.426c-.045-.047-.795-.465-.795-.465s-1.135,1.9-2.732,2.131c0,0,2.2-1.163,2.452-2.29l-1.172-.551a4.954,4.954,0,0,1-2.916,2.4s2.253-1.294,2.65-2.5l-1.227-.4s-1.113,1.987-2.623,2.26c0,0,2.449-1.759,2.335-2.332a6.135,6.135,0,0,0-1.49-.229s-.832,1.413-1.724,1.49c0,0,1.513-1.346,1.4-1.535a6.686,6.686,0,0,0-2.407.447,4.849,4.849,0,0,1,2.392-.7,2.67,2.67,0,0,0-1.344-.73s.857-.415,1.739.73a6.293,6.293,0,0,1,1.408.169,5.941,5.941,0,0,0-1.508-1.754s1.163.134,1.836,1.848l1.242.373a8.256,8.256,0,0,0-1.528-2.206s1.167.32,1.833,2.325l1.155.539a9.982,9.982,0,0,0-1.242-2.236,3.929,3.929,0,0,1,1.58,2.412l.728.452s-.467-1.105-.631-1.411-.094-.373-.094-.373a4.082,4.082,0,0,1,1.036,1.967A9.615,9.615,0,0,0,841.172,207.874Z",
    transform: "translate(-647.884 -166.195)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M726.231,266.77s.248-9.464-6.327-8.13a1.619,1.619,0,0,0-1.674.9s.5,0,.358.956a4.365,4.365,0,0,0-.015,1.028,2.123,2.123,0,0,0,.559,1.242h0s1.185,2.618,5.559,3.507c0,0,.971.733,1.215.693l-.745-1.57a2.867,2.867,0,0,1-2.1.186s2.062-.122,2-.425c0-.062-.427-.817-.427-.817s-1.972,1.006-3.45.345c0,0,2.484.186,3.3-.631l-.693-1.1a4.962,4.962,0,0,1-3.746.477s2.6.1,3.579-.708l-.827-.994s-2,1.1-3.425.517c0,0,3.011-.181,3.229-.73a6.442,6.442,0,0,0-1.143-.994s-1.456.745-2.251.343c0,0,1.987-.333,2-.554a6.667,6.667,0,0,0-2.275-.9,4.837,4.837,0,0,1,2.4.686,2.67,2.67,0,0,0-.745-1.334s.946.107,1.076,1.54a6.172,6.172,0,0,1,1.1.894,5.81,5.81,0,0,0-.343-2.288,2.577,2.577,0,0,1,.571,2.541l.852.979a8.317,8.317,0,0,0-.117-2.68s.815.892.313,2.944l.688,1.071a9.9,9.9,0,0,0,.137-2.568,3.942,3.942,0,0,1,.05,2.884l.378.77s.191-1.185.216-1.53.119-.368.119-.368a4.079,4.079,0,0,1-.171,2.218A9.468,9.468,0,0,0,726.231,266.77Z",
    transform: "translate(-563.479 -207.964)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 6.689,
    cy: 1.13,
    rx: 6.689,
    ry: 1.13,
    transform: "translate(166.933 176.802)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 6.689,
    cy: 1.13,
    rx: 6.689,
    ry: 1.13,
    transform: "translate(142.547 193.962)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 6.689,
    cy: 1.13,
    rx: 6.689,
    ry: 1.13,
    transform: "translate(16.444 185.171)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 6.689,
    cy: 1.13,
    rx: 6.689,
    ry: 1.13,
    transform: "translate(193.285 192.832)",
    fill: "#08c4bb",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 9.988,
    cy: 1.689,
    rx: 9.988,
    ry: 1.689,
    transform: "translate(196.952 177.932)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M917.044,753.08a2.884,2.884,0,0,0,.951-1.436,1.276,1.276,0,0,0-.663-1.463,1.875,1.875,0,0,0-1.761.616,2.36,2.36,0,0,1-1.709.827,2.608,2.608,0,0,0,.8-2.437,1.021,1.021,0,0,0-.224-.5c-.34-.363-.954-.206-1.361.08-1.292.909-1.652,2.663-1.659,4.243a7.977,7.977,0,0,1-.022-1.739,1.784,1.784,0,0,0-.658-1.545,1.965,1.965,0,0,0-.994-.248,2.075,2.075,0,0,0-1.625.462,1.6,1.6,0,0,0,.062,1.987,6.423,6.423,0,0,0,1.682,1.346,3.758,3.758,0,0,1,1.2,1.145,1.165,1.165,0,0,1,.087.2H914.8A10.047,10.047,0,0,0,917.044,753.08Z",
    transform: "translate(-705.963 -576.223)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M170.29,777.633s3.813-.117,4.968-.937,5.87-1.8,6.155-.482,5.733,6.53,1.426,6.565-10.008-.671-11.156-1.371S170.29,777.633,170.29,777.633Z",
    transform: "translate(-151.648 -596.585)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M182.911,788.545c-4.307.035-10.008-.671-11.156-1.371-.874-.532-1.222-2.442-1.339-3.324h-.127s.248,3.078,1.389,3.776,6.848,1.406,11.156,1.371c1.242,0,1.672-.452,1.649-1.108C184.31,788.289,183.835,788.537,182.911,788.545Z",
    transform: "translate(-151.648 -602.808)",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedemptionsImage);
export default __webpack_public_path__ + "static/media/redemptions-image.4b862b8528fdcbcb3705165b114d71c8.svg";
export { ForwardRef as ReactComponent };